<template>
  <div
    class="sidebar bg-white d-flex flex-column justify-content-between py-3 px-2 shadow-sm rounded"
  >
    <div class="sidebar-nav">
      <div v-for="item in navItems" :key="item.label" class="mb-3 text-center">
        <button
          class="btn w-100 d-flex flex-column align-items-center custom-nav-btn"
          :class="{
            active:
              currentRoute &&
              currentRoute.toLowerCase() == item.name.toLowerCase(),
          }"
          @click="navigationAction(item)"
        >
          <i :class="['bi', item.icon, 'fs-4']"></i>
          <small class="mt-1">{{ item.label }}</small>
        </button>
      </div>
    </div>
    <div class="mb-3 text-center">
      <button
        class="btn w-100 d-flex flex-column align-items-center custom-nav-btn"
        @click="handleSignOut()"
      >
        <i class="bi bi-door-open fs-4"></i>
        <small class="mt-1"> Log Out </small>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "SidebarComponent",
  emits: ["navigate"],
  data() {
    return {
      userNavItems: [
        {
          label: "POS",
          icon: "bi-cart",
          route: "/pos",
          name: "POS",
        },
        {
          label: "Orders",
          icon: "bi-box-seam",
          route: "/orders",
          name: "Orders",
        },
        // {
        //   label: "Previous",
        //   icon: "bi-caret-left-fill",
        //   route: "/orders/previous",
        //   name: "PreviousOrders",
        // },
        {
          label: "On Hold",
          icon: "bi-pause-circle",
          route: "/orders/onHold",
          name: "OnHoldOrders",
        },
        // {
        //   label: "Reports",
        //   icon: "bi-pie-chart",
        //   route: "/reports",
        //   name: "Reports",
        // },
        // {
        //   label: "Settings",
        //   icon: "bi-gear",
        //   route: "/settings",
        //   name: "Settings",
        // },
      ],
      adminNavItems: [
        {
          label: "Orders",
          icon: "bi-box-seam",
          route: "/orders",
          name: "Orders",
        },
        {
          label: "Products",
          icon: "bi-boxes",
          route: "/products",
          name: "Products",
        },
        // {
        //   label: "Print Barcodes",
        //   icon: "bi bi-upc-scan",
        //   route: "/printBarcodes",
        //   name: "Print Product Barcodes",
        // },
        {
          label: "Reports",
          icon: "bi-pie-chart",
          route: "/reports",
          name: "Reports",
        },
        {
          label: "Users",
          icon: "bi-person",
          route: "/users",
          name: "Users",
        },
        // {
        //   label: "Settings",
        //   icon: "bi-gear",
        //   route: "/settings",
        //   name: "Settings",
        // },
      ],
      superAdminNavItems: [
        {
          label: "Home",
          icon: "bi-house",
          route: "/",
          name: "Redirect",
        },
        {
          label: "POS",
          icon: "bi-cart",
          route: "/pos",
          name: "POS",
        },
        {
          label: "Orders",
          icon: "bi-box-seam",
          route: "/orders",
          name: "Orders",
        },
        {
          label: "Products",
          icon: "bi-boxes",
          route: "/products",
          name: "Products",
        },
        {
          label: "Print Barcodes",
          icon: "bi bi-upc-scan",
          route: "/printBarcodes",
          name: "Print Product Barcodes",
        },
        {
          label: "Reports",
          icon: "bi-pie-chart",
          route: "/reports",
          name: "Reports",
        },
        {
          label: "Users",
          icon: "bi-person",
          route: "/users",
          name: "Users",
        },
        {
          label: "Outlets",
          icon: "bi-shop",
          route: "/outlets",
          name: "Outlets",
        },
        {
          label: "Settings",
          icon: "bi-gear",
          route: "/settings",
          name: "Settings",
        },
      ],
    };
  },
  computed: {
    currentRoute() {
      return this.$route.name;
    },
    navItems() {
      const user = this.$store.state.auth.user;

      if (!user) return [];

      switch (user.type) {
        case "super_user":
          return this.superAdminNavItems;
        case "admin":
          return this.adminNavItems;
        default:
          return this.userNavItems;
      }
    },
  },
  methods: {
    ...mapActions("auth", ["signOut"]),
    async handleSignOut() {
      await this.signOut();
      this.$emit("navigate");
      this.$router.push("/signIn");
    },
    navigationAction(navItem) {
      this.$router.push(navItem.route);
      this.$emit("navigate");
    },
  },
};
</script>

<style scoped>
.sidebar {
  width: 100px;
  height: 100%;
}

.sidebar-nav {
  flex-grow: 1;
  overflow-y: auto;
  min-height: 0;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.sidebar-nav::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}

.custom-nav-btn {
  border: none;
  border-radius: 12px;
  background-color: transparent;
  color: #333;
  transition: background-color 0.2s, color 0.2s;
}

.custom-nav-btn.active {
  background-color: #fff3cd;
  color: rgb(255 193 7);
  font-weight: 600;
}

@media (max-width: 767.98px) {
  .sidebar {
    position: fixed;
    z-index: 1050;
    height: calc(100vh - 70px);
    left: 0;
    top: 70px;
  }
}
</style>
